import { DeviceMobile, X } from 'phosphor-react';
import React, { useState } from 'react';
import { Button } from '../../../components/Button';
import InputMask from '../../../components/InputMask';
import * as S from './styles';

interface RegisterPhoneProps {
  handleCloseModal: () => void;
  handleSendPhone: (phone: string) => void;
}

export function RegisterPhone({
  handleCloseModal,
  handleSendPhone,
}: RegisterPhoneProps) {
  const [phone, setPhone] = useState<string>('');

  return (
    <S.ModalContainer>
      <S.CloseButton>
        <button onClick={handleCloseModal}>
          <X size={24} color="#0b0909" />
        </button>
      </S.CloseButton>
      <S.MessageContainer>
        <span>
          <DeviceMobile size={30} color="#007467" />
        </span>
        <label>
          <h4>Adicionar Telefone</h4>
          <p>
            Não encontramos um telefone cadastrado. Informe seu telefone para
            continuar.
          </p>
        </label>
      </S.MessageContainer>
      <InputMask
        placeholder="Número de telefone"
        onChange={(e) => setPhone(e.target.value)}
        value={phone}
        mask="(99) 99999-9999"
      />
      <S.ButtonsContainer>
        <Button onClick={handleCloseModal}>Cancelar</Button>
        <Button
          onClick={() => {
            handleSendPhone(phone);
          }}
        >
          Adicionar
        </Button>
      </S.ButtonsContainer>
    </S.ModalContainer>
  );
}
